<template>
  <div>
    <section class="wrap" v-show="stepState == 1">
      <!-- 进度条 -->
      <div style="margin: 10px 0 20px; width: 900px">
        <el-steps :active="0" finish-status="success" align-center>
          <el-step title="基础信息"></el-step>
          <el-step title="目录及价格"></el-step>
          <el-step title="分享设置"></el-step>
        </el-steps>
      </div>
      <!-- 表单 -->
      <el-form ref="firstStep" :model="form" label-width="200px" :rules="rules">
        <el-card class="courseList">
          <span>基础信息</span>
          <el-form-item label="课程名称" prop="title">
            <el-input
              placeholder="请输入课程名称"
              v-model.trim="form.title"
              @blur="changeShareTitle"
              class="width_short"
              maxlength="50"
            ></el-input>
            <span style="color: grey; margin: 0 10px; opacity: 0.8">50字以内</span>
          </el-form-item>
          <el-form-item label="课程封面" prop="coverImg" class="is-required">
            <el-upload
              class="avatar-uploader"
              :action="commonUrl.uploadImg"
              :headers="commonUrl.headers"
              :data="mediaObj"
              :multiple="false"
              :on-success="coverImgSuccess"
              :show-file-list="false"
            >
              <img v-if="form.coverImg" class="avatar" :src="commonUrl.imgPrefix_qN + form.coverImg" />
              <i v-else class="iconfont icon-picture-add"></i>
            </el-upload>
            <div>图片比例16:9，建议750*422</div>
          </el-form-item>
          <el-form-item label="上架时间" prop="createTime" class="is-required">
            <el-date-picker
              v-model="form.createTime"
              type="datetime"
              :disabled="PAGEKEY == 'docCourse_edit' && !form.offline"
              placeholder="选择日期时间"
              format="yyyy-MM-dd HH:mm"
              value-format="yyyy-MM-dd HH:mm:ss"
            ></el-date-picker>
            -
            <el-date-picker
              v-model="form.offlineTime"
              type="datetime"
              placeholder="选择日期时间"
              format="yyyy-MM-dd HH:mm"
              value-format="yyyy-MM-dd HH:mm:ss"
            ></el-date-picker>
            <span style="color: grey; margin: 0 10px; opacity: 0.8"
              >上架时间不能是过去时间，如未填写下架时间，则不自动下架</span
            >
          </el-form-item>

          <!-- 选择学科&栏目 -->
          <el-form-item label="选择学科&栏目" class="is-required">
            <div v-for="(item, index) in disciplineList" :key="index">
              <div v-if="item.status == 1 && item.disciplineSubjects.length && form.disciplines[index]">
                {{ item.name }}
                <el-switch
                  v-model="form.disciplines[index].disciplineId"
                  inactive-color="#ff4949"
                  active-color="#13ce66"
                  :active-value="item.id"
                  :inactive-value="-1"
                >
                </el-switch>
                <el-card v-if="form.disciplines[index].disciplineId != -1">
                  <el-checkbox-group v-model="form.disciplines[index].subjectIds">
                    <el-checkbox v-for="(column, index) in item.disciplineSubjects" :key="index" :label="column.id">{{
                      column.name
                    }}</el-checkbox>
                  </el-checkbox-group>
                </el-card>
              </div>
            </div>
          </el-form-item>

          <!-- 会员专享 -->
          <el-form-item label="会员专享" class="is-required">
            <el-switch
              v-model="form.isVipExclusive"
              inactive-color="#ff4949"
              active-color="#13ce66"
              :active-value="true"
              :inactive-value="false"
            >
            </el-switch>
          </el-form-item>

          <!-- 课程类型 -->
          <el-form-item label="课程类型" class="is-required">
            <el-checkbox-group v-model="form.types">
              <el-checkbox label="1">会员课程</el-checkbox>
              <el-checkbox label="2">广告课程</el-checkbox>
            </el-checkbox-group>
            <div>
              <el-radio-group v-model="form.subType" style="margin-left: 20px"
               v-if="form.types.includes('2')">
                <el-radio :label="1">免费广告</el-radio>
                <el-radio :label="2">收费广告</el-radio>
              </el-radio-group>
            </div>
          </el-form-item>

          <!-- 直播专题 -->
          <el-form-item label="直播专题">
            <el-checkbox-group v-model="form.subjectType">
              <el-checkbox label="1">呗呗早7:00</el-checkbox>
              <el-checkbox label="2">学术会议</el-checkbox>
              <el-checkbox label="3">每日直播</el-checkbox>
            </el-checkbox-group>
          </el-form-item>

          <el-form-item label="自定义营销标签">
            <el-input
              placeholder="请输入自定义营销标签,建议不超过4个字"
              v-model.trim="form.marketingText"
              class="width_short"
              maxlength="4"
            ></el-input>
            <span style="color: grey; margin: 0 10px; opacity: 0.8">4个字以内</span>
          </el-form-item>
          <el-form-item label="生效时间">
            <datetime-range ref="datetimerange" :defaultType="true" :defaultTime="form.timerange"></datetime-range>
          </el-form-item>
          <el-form-item label="课程卖点">
            <el-row>
              <el-input
                maxlength="5"
                v-model.trim="sellingPoints"
                placeholder="请输入内容"
                size="small"
                style="width: 200px"
                clearable
              ></el-input>
              <el-button type="primary" size="small" @click="addTag">贴上</el-button>
              <span style="color: grey; margin: 0 10px; opacity: 0.8"
                >5个字以内，最多加3个，主要用于搜索和展示特点</span
              >
            </el-row>
            <el-tag
              v-for="tag in tags"
              @close="handleClose(tag)"
              :key="tag.name"
              closable
              :disable-transitions="false"
              style="margin: 0 5px"
            >
              {{ tag.name }}
            </el-tag>
          </el-form-item>

          <el-form-item label="合同编号">
            <el-input maxlength="200" v-model="contractCode" size="small" style="width: 400px"></el-input>
            <span style="color: grey; margin: 0 10px; opacity: 0.8"> 多个合同拿“,”逗号分开；200个字以内</span>
          </el-form-item>
          <el-form-item label="确认表编号">
            <el-input maxlength="9999" v-model="confirmCode" size="small" style="width: 400px"></el-input>
          </el-form-item>
        </el-card>

        <!-- 允许分享、公开课程 -->
        <el-card class="courseList">
          <span>权限&权益设置</span>
          <el-form-item label="允许分享">
            <el-switch
              v-model="form.shareable"
              inactive-color="#ff4949"
              active-color="#13ce66"
              :active-value="1"
              :inactive-value="0"
            >
            </el-switch>
            <span style="color: grey; margin: 0 10px; opacity: 0.8">关闭后，将隐藏分享按钮</span>
          </el-form-item>
          <el-form-item label="公开课程">
            <el-switch
              v-model="form.overt"
              inactive-color="#ff4949"
              active-color="#13ce66"
              :active-value="1"
              :inactive-value="0"
            ></el-switch>
            <span style="color: grey; margin: 0 10px; opacity: 0.8"
              >关闭后，将无法被搜索到，不会在常规列表中显示出来</span
            >
          </el-form-item>
          <el-form-item label="会员上新永久免费">
            <el-switch
              :disabled="isdisabled"
              v-model="form.vipFreeFlag"
              inactive-color="#ff4949"
              active-color="#13ce66"
              :active-value="1"
              :inactive-value="0"
            ></el-switch>
            <span style="color: grey; margin: 0 10px; opacity: 0.8"
              >开启后，将在直播结束后的当晚12点，自动把会员永久加入学习,必须先打开会员免费开关</span
            >
          </el-form-item>
          <!-- wap to app -->
          <el-form-item label="是否支持WAP观看">
            <el-switch
              :disabled="isdisabled"
              v-model="form.isWapWatch"
              inactive-color="#ff4949"
              active-color="#13ce66"
              :active-value="true"
              :inactive-value="false"
            ></el-switch>
            <span style="color: grey; margin: 0 10px; opacity: 0.8"> 打开后即WAP可观看视频</span>
          </el-form-item>
        </el-card>

        <!-- 荣誉证书 -->
        <el-card class="courseList">
          <span>荣誉证书</span>
          <el-form label-width="150px">
            <el-form-item label="是否开启荣誉证书：">
              <el-switch
                v-model="form.hasCert"
                inactive-color="#ff4949"
                active-color="#13ce66"
                :active-value="1"
                :inactive-value="0"
              ></el-switch>
              <span style="color: grey; margin: 0 10px; opacity: 0.8">开启后，学习进度超过{{form.courseCertificationDto.learnProcess}}%时，可以获得证书</span>
            </el-form-item>
            <el-form-item label="学习进度：" class="is-required"  v-if="form.hasCert">
              <el-input-number size="small" :precision="1" v-model.trim="form.courseCertificationDto.learnProcess" :min="50" :max="100" class="width_short">
              </el-input-number>
              <span>%</span>
              <span style="color: grey; margin: 0 10px; opacity: 0.8">最低设置50%</span>
            </el-form-item>
            <el-form-item label="证书简介：" class="is-required" v-if="form.hasCert">
              <el-input
                placeholder="请输入证书简介"
                v-model.trim="form.courseCertificationDto.introduce"
                class="width_short"
                type="textarea"
                maxlength="100"
              ></el-input>
              <span style="color: grey; margin: 0 10px; opacity: 0.8">100字以内，不支持符号、表情</span>
            </el-form-item>
          </el-form>
        </el-card>

        <!-- 课程简介 -->
        <el-card class="courseList">
          <span>课程简介</span>
          <el-form-item label="课程简介：" prop="summary" class="is-required">
            <v-editor
              :defaultMsg="form.summary"
              :config="editorDefault.config"
              ref="courseUeditorEdit"
              :editorId="editorDefault.editorId"
            ></v-editor>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="small" @click="nextStep('firstStep')">下一步</el-button>
          </el-form-item>
        </el-card>
      </el-form>
    </section>
    <!-- 第二步 -->
    <section v-show="stepState == 2">
      <!-- 进度条 -->
      <div style="margin: 10px 0 20px; width: 900px">
        <el-steps :active="1" finish-status="success" align-center>
          <el-step title="基础信息"></el-step>
          <el-step title="目录及价格"></el-step>
          <el-step title="分享设置"></el-step>
        </el-steps>
      </div>
      <el-card class="self-el-card">
        <!-- 价格及分成 -->
        <p class="title">价格及分成设置</p>
        <el-card class="courseList">
          <el-form ref="secondStep" :model="form2" :rules="rules2" label-width="200px" style="padding-top: 20px">
            <el-form-item label="销售价（元）：" prop="price">
              <el-input-number size="small" :precision="1" v-model.trim="form2.price" :min="0" class="width_short">
              </el-input-number>
              <span style="color: grey; margin: 0 10px; opacity: 0.8">当销售价为0元时，即该课程免费</span>
            </el-form-item>
            <el-form-item label="讲师抽成：" class="is-required">
              <el-radio-group v-model="form2.isDraw">
                <el-radio :label="0">否</el-radio>
                <el-radio :label="1">是</el-radio>
              </el-radio-group>
              <span style="color: grey; margin: 0 10px; opacity: 0.8">仅包含课程部分讲师抽成</span>
            </el-form-item>
            <!-- 成本 -->
            <el-form-item label="成本（元）：" class="is-required" prop="cost" v-show="form2.isDraw == 1">
              <el-input-number
                size="small"
                :precision="1"
                v-model.trim="form2.cost"
                :max="9999999999"
                :min="0"
                class="width_short"
              ></el-input-number>
              <span style="color: grey; margin: 0 10px; opacity: 0.8">包括讲师费用及推广费用，不考虑人员工资成本</span>
            </el-form-item>
            <!-- 抽成 -->
            <el-form-item label="抽成比例：" v-show="form2.isDraw == 1" class="is-required" prop="drawProportion">
              <el-input-number
                size="small"
                :precision="2"
                v-model.trim="form2.drawProportion"
                :max="100"
                :min="0"
                class="width_short"
              ></el-input-number>
              %
              <el-tag type="danger" size="mini" style="margin-left: 20px">
                此处为讲师的抽成比例（以销售价为依据）</el-tag
              >
            </el-form-item>
          </el-form>
        </el-card>

        <!-- 课程目录 -->
        <p class="title">课程目录</p>
        <!-- 章节 -->
        <el-card class="courseList" v-for="(item, index) in form2.chapterList" :key="index">
          <div slot="header" class="clearfix">
            <span style="color: red; opacity: 0.5; display: inline-block; margin-top: 5px">*</span>
            <span style="color: grey; font-size: 15px; margin: 0 5px">章节名称</span>
            <el-input
              placeholder="自定义章节名称"
              clearable
              v-model.trim="item.name"
              @input="updateDom"
              class="courseList_title"
              maxlength="100"
            ></el-input>
            <span style="color: grey; margin: 0 10px; opacity: 0.8">100字以内</span>
            <el-button class="courseList_opearte" type="text" @click="addChapter">添加章节</el-button>
            <el-button
              class="courseList_opearte"
              type="text"
              style="color: red"
              v-if="index != 0"
              @click="removeChapter(index)"
            >
              删除章节</el-button
            >
          </div>
          <div class="courseBody">
            <!-- 小节 -->
            <el-row v-for="(child, num) in item.sourceList" :key="num">
              <el-col :span="8">
                <el-card class="courseItem">
                  <p>
                    <el-tag size="mini" class="courseItem_tag">
                      {{ [child.state, child.type] | courseTagFilter }}</el-tag
                    >
                    <span class="courseItem_title"> {{ child.title }}</span>
                  </p>
                  <p class="courseItem_detail">
                    <span>{{ child.teacherName }}</span>
                    <span>{{ child | timeFilter }}</span>
                  </p>
                </el-card>
              </el-col>
              <el-col :span="4" class="courseItem_draw" v-show="child.type != 10 && form2.isDraw == 1">
                <p><span style="color: #f56c6c">* </span>每个课程源分成比例</p>
                <el-input-number
                  size="small"
                  :precision="2"
                  v-model.trim="child.drawProportion"
                  :max="9999999999"
                  @change="updateDom"
                  :min="0"
                  class="input"
                ></el-input-number
                >%
              </el-col>
              <el-col :span="4" class="courseItem_free" v-show="child.type != 3">
                <template>
                  <span>是否免费：</span>
                  <el-switch
                    @click.native="handleClickSourceSwitch(child)"
                    :disabled="child.isOnlyVipWatch && !child.isLook"
                    v-model="child.isLook"
                    inactive-color="#ff4949"
                    active-color="#13ce66"
                    :active-value="-1"
                    :inactive-value="0"
                    @change="updateDom"
                  ></el-switch>
                </template>
              </el-col>

              <el-col :span="4" class="courseItem_draw" v-show="child.type == 10">
                <span>进度锁定：</span>
                <el-switch
                  v-model="child.quizLockStatus"
                  inactive-color="#ff4949"
                  active-color="#13ce66"
                  :active-value="1"
                  :inactive-value="0"
                  @change="updateDom"
                ></el-switch>
              </el-col>
              <el-col :span="6" class="courseItem_draw">
                <span style="color: #f56c6c">* </span>
                <span>权重</span>
                <el-input-number
                  size="small"
                  class="inp"
                  placeholder="请输入"
                  :min="0"
                  @change="updateDom"
                  v-model.trim="child.weight"
                ></el-input-number>
              </el-col>
              <el-col :span="2" class="courseItem_draw">
                <el-button type="danger" size="mini" @click="removeCourseItem(index, num)">删除</el-button>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-button type="primary" plain style="width: 100%" @click="openSelectCourseOrgin(index)">
                  <i class="iconfont icon-add"></i>
                  关联课程源
                </el-button>
              </el-col>
              <el-col :span="11" style="float: right">
                <el-button type="warning" plain style="width: 100%" @click="openSelectPaper(index)">
                  <i class="iconfont icon-add"></i>
                  关联测评
                </el-button>
              </el-col>
            </el-row>
          </div>
        </el-card>
        <el-form label-width="200px" style="padding-top: 20px">
          <el-form-item>
            <el-button type="info" size="small" @click="prevStep">上一步</el-button>
            <el-button type="success" size="small" @click="submitStep2" :loading="submitStep">直接保存</el-button>
            <el-button type="primary" size="small" @click="thirdStep">下一步</el-button>
          </el-form-item>
        </el-form>
      </el-card>
      <!--选择课程源组件-->
      <select-course ref="selectCourseOrgin" :userType="2" @select-submit="choiceCourseCallback"> </select-course>
      <select-paper ref="selectPaper" @select-submit="choicePaperCallback"></select-paper>
    </section>
    <!-- 第三步 -->
    <section v-show="stepState == 3">
      <!-- 进度条 -->
      <div style="margin: 10px 0 20px; width: 900px">
        <el-steps :active="2" finish-status="success" align-center>
          <el-step title="基础信息"></el-step>
          <el-step title="目录及价格"></el-step>
          <el-step title="分享设置"></el-step>
        </el-steps>
      </div>

      <el-form ref="thirdStep" :model="form" label-width="200px" style="padding-top: 20px">
        <!-- h5分享 -->
        <el-card class="courseList">
          <span>h5分享</span>
          <el-form-item label="分享标题：" prop="shareTitle">
            <el-input placeholder="默认为课程标题" v-model.trim="form.shareTitle" class="width_short" maxlength="50">
            </el-input>
          </el-form-item>
          <el-form-item label="分享描述：" prop="shareDesc">
            <el-input
              placeholder="默认为“学好医，上呗呗”"
              v-model.trim="form.shareDesc"
              class="width_short"
              maxlength="50"
            >
            </el-input>
          </el-form-item>
          <el-form-item label="分享封面图：" prop="shareImg">
            <el-upload
              class="avatar-uploader"
              :action="commonUrl.uploadImg"
              :data="mediaObj"
              :multiple="false"
              :on-success="shareImgSuccess"
              :before-upload="beforeUpload"
              :headers="commonUrl.headers"
              :show-file-list="false"
            >
              <img v-if="form.shareImg" class="avatar" :src="commonUrl.imgPrefix_qN + form.shareImg" />
              <i v-else class="iconfont icon-picture-add"></i>
            </el-upload>
            <div style="color: grey; margin: 0 10px; opacity: 0.8">图片比例1:1，建议200*200，大小控制128k以内</div>
          </el-form-item>
        </el-card>
      </el-form>
      <el-form label-width="200px" style="padding-top: 20px">
        <el-form-item>
          <el-button type="info" size="small" @click="secondStep">上一步</el-button>
          <el-button
            type="success"
            size="small"
            :loading="submitStep && !isPublish"
            :disabled="submitStep && isPublish"
            @click="submitStep2"
            >保存</el-button
          >
          <el-button
            type="success"
            size="small"
            :loading="submitStep && isPublish"
            :disabled="submitStep && !isPublish"
            @click="publish"
            >保存并发布</el-button
          >
        </el-form-item>
      </el-form>
    </section>
  </div>
</template>

<script scoped>
import myUpload from 'vue-image-crop-upload'
import exchange from '@/utils/exchange'
import commonApi from '@/api/common'
import datetime from '@/components/datetime'
import datetimeRange from '@/components/datetimeRange'
import docCourseApi from '@/api/contentManage/docCourseManage'
import selectCourse from '@/components/selectSource/selectCourseOrgin'
import selectDoctor from '@/components/selectSource/selectDoctor'
import selectPaper from '@/components/selectSource/selectPaper'
import UE from '@/components/uedtior'
export default {
  name: 'coursePage',
  props: {
    PAGEKEY: {
      type: String,
      default: () => ''
    },
    PAGEBACK: {
      type: String,
      default: () => ''
    }
  },
  data() {
    var validatePass = (rule, value, callback) => {
      this.form.summary = this.$refs.courseUeditorEdit.getUEContent()
      if (this.form.summary === '') {
        callback(new Error('请输入课程详情'))
      } else {
        callback()
      }
    }
    var validateCost = (rule, value, callback) => {
      if (this.form2.cost === '') {
        callback(new Error('请输入成本'))
      } else {
        callback()
      }
    }
    var validateProportion = (rule, value, callback) => {
      if (this.form2.isDraw === 1 && this.form2.drawProportion === '') {
        callback(new Error('请输入抽成比例'))
      } else {
        callback()
      }
    }
    return {
      courseId: '',
      //课程卖点
      sellingPoints: '',
      //课程卖点数组
      tags: [],
      //会员上新永久免费开关
      isdisabled: false,
      // 学科栏目
      disciplineList: [],

      //合同编号
      contractCode: '',
      // 确认单号
      confirmCode: '',
      //选择的结算主体
      collectionSubjectId: '',
      //结算主体
      payData: [],
      stepState: 1, //1第一步，2第二步
      submitStep: false,
      isPublish: false,
      commonUrl: commonApi.commonUrl,
      mediaObj: {
        mediaJson: JSON.stringify({
          appType: 3,
          type: 1,
          picContent: {
            suffix: 'png'
          }
        })
      },
      form: {
        freeMembership: 1, //会员免费
        vipFree: 0, //会员上新永久免费
        title: '', //名称
        advertisingSlogan: '', //广告语
        createTime: '',
        offlineTime: '',
        offline: 0, // 是否下架
        startVersion: 0, //适配最低版本
        endVersion: 10000, //适配最高版本
        locationUrl: '', //网页跳转
        timerange: [],
        offlinePos: '',
        shareable: 1,
        overt: 1,
        isVipExclusive: false, // 会员专享
        types: [], // 课程类型
        subType: 1, // 课程类型
        subjectType: [], // 所属专题
        courseType: [],
        advertise: 0, // 广告类型
        disciplines: [], // 学科及栏目
        vipFreeFlag: 0,
        isWapWatch: true,
        coverImg: '', //封面图
        miniCardImg: '', //小程序卡片图
        shareImg: '', //分享朋友圈小图
        shareTitle: '', //朋友圈标题
        shareDesc: '',
        marketingText: '', //自定义营销标签
        summary: '', //课程简介
        userType: 2, //1：孕妈 2：医生
        coverImg: '', //封面图
        miniCardImg: '', //小程序卡片图
        shareImg: '', //分享朋友圈小图
        shareTitle: '', //朋友圈标题
        hasCert: 0, //有没有荣誉证书
        courseCertificationDto: {
          introduce: '',
          learnProcess: 50
        } //证书简介
      },
      rules: {
        title: {
          required: true,
          message: '请输入课程名称',
          trigger: 'blur'
        },
        coverImg: {
          required: true,
          message: '请上传封面图',
          trigger: 'blur'
        },
        summary: {
          validator: validatePass,
          trigger: 'blur'
        }
      },
      form2: {
        chapterList: [
          {
            name: '',
            sourceList: [],
            weight: 0
          }
        ], //课程章节
        price: 0, //销售价格
        isDraw: 1, //是否抽成
        drawProportion: 0, //讲师抽成比例
        cost: 0, //成本
        hasCert: 0,
        courseCertificationDto: {
          introduce: '',
          learnProcess: 50
        }
      },
      secondStepChapterList: [],
      chapterIndex: 0,
      // teacherGet: 0, //老师抽成
      rules2: {
        price: {
          required: true,
          message: '请输入销售价',
          trigger: 'blur'
        },
        cost: {
          validator: validateCost,
          trigger: 'blur'
        },
        drawProportion: {
          validator: validateProportion,
          trigger: 'blur'
        }
      },
      dialogTags: {
        id: '',
        title: '',
        active: -1,
        orignName: '',
        orignTags: [],
        chooseName: '',
        chooseTags: [],
        show: false
      },
      // ue
      editorDefault: {
        editorId: new Date().getTime().toString(),
        defaultMsg: '',
        config: {
          initialFrameWidth: 500,
          initialFrameHeight: 550,
          autoHeightEnabled: false
        }
      },
      province: [
        {
          code: '',
          name: '全部省份'
        }
      ],
      provinceVal: '',
      allCitys: ''
    }
  },
  components: {
    'my-upload': myUpload,
    'v-editor': UE,
    selectCourse,
    selectDoctor,
    selectPaper,
    datetime,
    datetimeRange
  },
  computed: {
    teacherGet: function () {
      return (this.form2.cost * this.form2.drawProportion).toFixed(2)
    }
  },
  mounted() {
    this.getCollectionSubject()
  },
  activated() {
    Promise.all([this.getCourseInfo(), this.getDisciplineList()]).then((res) => {
      let disciplinesRes = res[0].disciplines || []
      let disciplines = res[1] || []
      for (let i = 0; i < disciplinesRes.length; i++) {
        for (let j = 0; j < this.disciplineList.length; j++) {
          if (disciplinesRes[i].disciplineId === this.disciplineList[j].id) {
            disciplines[j] = disciplinesRes[i]
          }
        }
      }
      this.form.disciplines = disciplines
      // this.$forceUpdate()
    })
  },

  methods: {
    handleClickSourceSwitch(item) {
      if (!item.isOnlyVipWatch) return
      if (item.isLook === 0) {
        this.$message.warning('课程源已设置直播仅VIP观看，不可免费')
        return
      }
      item.isLook = 0
    },
    // 获取学科列表
    getDisciplineList() {
      return new Promise((resolve, reject) => {
        if (this.form.disciplines.length) {
          resolve(this.form.disciplines)
          return
        }
        docCourseApi.getDisciplineList().then((res) => {
          if (res.Success) {
            this.disciplineList = res.Data.result || []
            let disciplines = []
            disciplines.length = this.disciplineList.length
            disciplines = this.disciplineList.map((item) => {
              return {
                disciplineId: -1,
                subjectIds: []
              }
            })
            // this.form.disciplines = disciplines
            resolve(disciplines)
          } else {
            reject()
            this.$message.error(res.Msg)
          }
        })
      })
    },

    //增加课程卖点
    addTag() {
      if (this.tags.length > 2) {
        return
      } else {
        this.tags.push({
          name: this.sellingPoints
        })
      }
    },

    //删除tag标签
    handleClose(tag) {
      this.tags.splice(this.tags.indexOf(tag), 1)
    },

    //控制会员上新永久免费
    alwaysFreeChange() {
      this.isdisabled = !this.isdisabled
    },

    // 获取课程信息
    getCourseInfo() {
      return new Promise((resolve, reject) => {
        if (this.$route.params.id == this.courseId || !this.$route.params.id) {
          resolve({})
          return
        }
        this.courseId = this.$route.params.id
        docCourseApi
          .getCourseDetail({
            courseId: this.courseId
          })
          .then((res) => {
            if (res.Success) {
              /*格式化数据*/
              let data = res.Data
              resolve(data)
              //把tags标签转为对象数组
              let newArr = []
              if (data.tags && data.tags.length !== 0) {
                data.tags.forEach((item) => {
                  let obj = {}
                  obj['name'] = item
                  newArr.push(obj)
                })
              }

              this.collectionSubjectId = data.collectionSubjectId
              this.contractCode = data.contractCode
              this.confirmCode = data.confirmCode
              this.form.vipFree = data.vipFree
              this.form.isWapWatch = data.isWapWatch === null || data.isWapWatch === undefined ? true : data.isWapWatch // 兼容过去的课程 默认开启wap放
              this.tags = newArr
              this.form.title = data.title
              this.form.createTime = data.createTime
              this.form.offlineTime = data.offlineTime
              this.form.offline = data.offline
              this.form.advertisingSlogan = data.advertisingSlogan
              this.form.startVersion = data.startVersion
              this.form.endVersion = data.endVersion
              this.form.locationUrl = data.locationUrl
              this.form.coverImg = data.coverImg //封面图
              this.form.miniCardImg = data.miniCardImg //小程序卡片图
              this.form.shareImg = data.shareImg //分享朋友圈小图
              this.form.shareTitle = data.shareTitle //朋友圈标题
              this.form.shareDesc = data.shareDesc //朋友圈标题
              this.form.hasCert = data.hasCert //有没有荣幸证书
              this.form.courseCertificationDto.learnProcess = data.certInfo ? data.certInfo.learnProcess : 50 //学习进度
              this.form.courseCertificationDto.introduce = data.certInfo ? data.certInfo.introduce : '' //荣誉证书简介
              this.form.marketingText = data.marketingText
              this.form.shareable = data.shareable === 0 ? 0 : 1
              this.form.overt = data.overt === 0 ? 0 : 1
              this.form.summary = data.summary ? data.summary : '' //课程简介
              this.form.userType = 2 //1：孕妈 2：医生

              if (data.vipFree != null) {
                this.form.vipFree = data.vipFree
                this.form.vipFreeFlag = data.vipFree == 0 ? 0 : 1
              }
              this.form.isVipExclusive = data.isVipExclusive
              this.form.subjectType = data.subjectType ? data.subjectType.split(',') : []
              this.form.types = data.types ? data.types.split(',') : [] //课程类型
              this.form.subType = data.subType ? data.subType : 1 //课程类型
              /*步骤2*/
              this.form2 = {
                // chapterList: data.chapterList,
                price: exchange.parseWallet(data.price), //销售价格
                isDraw: data.drawProportion ? 1 : 0, //是否抽成,1抽成，0不抽成
                drawProportion: data.drawProportion ? data.drawProportion : 0, //讲师抽成比例
                cost: exchange.parseWallet(data.cost), //成本

                hasCert: data.hasCert || 0
              }
              for (let i = 0; i < data.chapterList.length; i++) {
                let sourceList = data.chapterList[i].sourceList
                for (let j = 0; j < sourceList.length; j++) {
                  sourceList[j].isLook =
                    sourceList[j].limitMinute != 0 && sourceList[j].limitMinute != -1 ? 1 : sourceList[j].limitMinute
                }
                data.chapterList[i].sourceList = sourceList
              }
              this.form2.chapterList = data.chapterList
            } else {
              this.$message.error(res.Msg)
            }
          })
          .catch((res) => {
            reject()
            console.log(res)
            this.$message.error('获取课程信息出错，请稍后重试！')
          })
      })
    },
    // 获取收款主体
    getCollectionSubject() {
      docCourseApi
        .getCollectionSubject({
          pageIndex: 1,
          pageSize: 50
        })
        .then((res) => {
          if (res.Success) {
            let list = res.Data.dataList || []
            this.payData = list
          } else {
            this.$message.error(res.Msg)
          }
        })
    },
    // 上传成功
    coverImgSuccess(res) {
      if (res.code.value === 2000000) {
        this.form.coverImg = res.data.url
        if (this.form.shareImg === '') {
          this.form.shareImg = res.data.url
        }
        if (this.form.miniCardImg === '') {
          this.form.miniCardImg = res.data.url
        }
      } else {
        this.$message.error(res.message)
      }
      this.updateDom()
    },
    // 上传成功
    miniCardImgSuccess(res) {
      if (res.code.value === 2000000) {
        this.form.miniCardImg = res.data.url
      } else {
        this.$message.error(res.message)
      }
      this.updateDom()
    },
    // 上传成功
    shareImgSuccess(res) {
      if (res.code.value === 2000000) {
        this.form.shareImg = res.data.url
      } else {
        this.$message.error(res.message)
      }
      this.updateDom()
    },
    // 上传限制
    beforeUpload(file) {
      const isLt128k = file.size / 1024 < 128
      if (!isLt128k) {
        this.$message.error('上传文件大小不能超过128kb!')
        return false
      }
      return isLt128k
    },
    // 填入朋友圈标题
    changeShareTitle() {
      if (this.form.shareTitle === '') {
        this.form.shareTitle = this.form.title
      }
    },
    //标签选择钩子
    choiceTagHandle(index) {
      let id = ''
      if (this.dialogTags.id == 2) {
        //城市
        id = this.dialogTags.orignTags[index].code
      } else {
        id = this.dialogTags.orignTags[index].id
      }
      let chooseTags = JSON.stringify(this.dialogTags.chooseTags)
      if (chooseTags.indexOf(id) == -1) {
        // this.dialogTags.orignTags[index].choiced = !this.dialogTags.orignTags[index].choiced
        this.dialogTags.chooseTags.push(this.dialogTags.orignTags[index])
      } else {
        // this.dialogTags.orignTags[index].choiced = true
        this.$forceUpdate()
      }
    },
    changeDepartTag(state, index, id) {
      if (state) {
        this.choiceTagHandle(index)
      } else {
        this.cancleChoiceTag(index, id)
      }
    },
    //取消选择
    cancleChoiceTag(index, id) {
      this.dialogTags.chooseTags.splice(index, 1)
      for (var i = 0; i < this.dialogTags.orignTags.length; i++) {
        if (
          this.dialogTags.orignTags[i].id == id ||
          (this.dialogTags.orignTags[i].code == id && this.dialogTags.id == 2)
        ) {
          this.dialogTags.orignTags[i].choiced = false
          break
        }
      }
    },
    //打开选择医生组件
    openDocSelectDialog() {
      this.$refs.selectDocDialog.open('选择医生')
    },
    // 下一步
    nextStep(formName) {
      this.$refs.firstStep.validate((valid) => {
        if (valid) {
          if (this.form.coverImg === '') {
            this.$message.error('请上传封面图！')
            return
          }
          if (!this.form.createTime) {
            this.$message.error('请选择上架时间')
            return
          }
          if (this.form.createTime && this.form.offlineTime) {
            const createTime = new Date(this.form.createTime).getTime()
            const offlineTime = new Date(this.form.offlineTime).getTime()
            if (createTime > offlineTime) {
              this.$message.error('下架时间不允许早于上架时间')
              return
            }
          }
          if (this.form.hasCert && !this.form.courseCertificationDto.introduce) {
            this.$message.error('请填写证书简介')
            return false
          }
          if (this.form.startVersion === '' || this.form.endVersion === '') {
            this.$message.error('请输入适配版本')
            return
          }
          // 是否选择了学科
          let isSubjectSelect = this.form.disciplines.some((item) => item.disciplineId !== -1)
          if (!isSubjectSelect) {
            this.$message.error('请选择学科')
            return
          }
          // 学科是否选择了栏目
          let isColumnEmpty = this.form.disciplines.some((item) => item.disciplineId !== -1 && !item.subjectIds.length)
          if (isColumnEmpty) {
            this.$message.error('请选择学科栏目')
            return
          }
          
          if (!this.form.types || !this.form.types.length) {
            this.$message.error('请选择课程类型')
            return
          }
          this.stepState = 2
        } else {
          this.$message.error('您有信息未正确填写！')
          return false
        }
      })
    },
    // 上一步
    prevStep() {
      this.stepState = 1
    },
    secondStep() {
      this.stepState = 2
    },
    // 第三步
    thirdStep() {
      if (!this.validSecondData()) return
      this.stepState = 3
    },
    validSecondData() {
      /*格式化第二步表单*/
      let chapterList = JSON.parse(JSON.stringify(this.form2.chapterList))
      let rate = 0
      let hasOnlyVip = false
      for (let i = 0; i < chapterList.length; i++) {
        if (chapterList[i].name === '' || chapterList[i].sourceList.length == 0) {
          this.$message.error('课程目录未填写完整！')
          return false
        }
        let sourceListCopy = []
        let sourceList = chapterList[i].sourceList
        for (let j = 0; j < sourceList.length; j++) {
          if (sourceList[j].isOnlyVipWatch) {
            hasOnlyVip = true
          }
          let obj = {}
          obj['sourceId'] = sourceList[j].sourceId || sourceList[j].id
          obj['teacherId'] = sourceList[j].teacherId
          obj['quizLockStatus'] = sourceList[j].quizLockStatus
          obj['limitMinute'] = sourceList[j].isLook == 1 ? sourceList[j].limitMinute : sourceList[j].isLook
          obj['weight'] = sourceList[j].weight
          if (this.form2.isDraw === 1) {
            obj['drawProportion'] = sourceList[j].drawProportion ? sourceList[j].drawProportion : 0
            rate = rate + obj['drawProportion']
          } else {
            obj['drawProportion'] = ''
          }
          sourceListCopy.push(obj)
        }
        chapterList[i].weight = i
        chapterList[i].sourceList = sourceListCopy
      }
      if (hasOnlyVip && this.form2.price <= 0) {
        this.$message.warning('课程源含直播仅VIP观看直播，销售价不能小于零')
        return false
      }
      if (this.form2.isDraw === 1 && rate != 100) {
        this.$message.error('课程分成比例总和必须为100%，您已填写的分成总和为' + rate + '%')
        return false
      }
      // if (!this.collectionSubjectId) {
      //   this.$message.error('请填写结算主体')
      //   return false
      // }
      if (this.form2.openZS) {
        if (!this.form2.a1 || !this.form2.a2 || !this.form2.a3 || !this.form2.a4) return false
      }
      this.secondStepChapterList = chapterList
      return chapterList
    },
    //打开选择课程源
    openSelectCourseOrgin(index) {
      this.chapterIndex = index
      this.$refs.selectCourseOrgin.getData()
      this.$refs.selectCourseOrgin.open('选择课程源')
    },
    // 选择课程源回调
    choiceCourseCallback(courseOrgin) {
      let oldData = JSON.stringify(this.form2.chapterList[this.chapterIndex].sourceList)
      let newData = []
      let j = 0
      for (let i = 0; i < courseOrgin.length; i++) {
        if (oldData.indexOf(courseOrgin[i].id) != -1) {
          continue
        }
        newData[j] = courseOrgin[i]
        newData[j].weight = 0
        newData[j].isLook = 0
        newData[j].limitMinute = 0
        newData[j].drawProportion = 0
        j++
      }
      this.form2.chapterList[this.chapterIndex].sourceList = JSON.parse(oldData).concat(newData)
      this.$forceUpdate()
    },
    openSelectPaper(index) {
      this.chapterIndex = index
      this.$refs.selectPaper.open('选择试卷')
    },
    choicePaperCallback(courseOrgin) {
      let oldData = JSON.stringify(this.form2.chapterList[this.chapterIndex].sourceList)
      let newData = []
      if (oldData.indexOf(courseOrgin.id) == -1) {
        newData[0] = courseOrgin
        newData[0].type = 10
        newData[0].isLook = 0
        newData[0].limitMinute = 0
        newData[0].drawProportion = 0
        newData[0].progressLock = 1
        newData[0].weight = 0
        newData[0].quizLockStatus = 1 // 评测是否上锁 1：有锁 0：无锁
      }
      this.form2.chapterList[this.chapterIndex].sourceList = JSON.parse(oldData).concat(newData)
      this.$forceUpdate()
    },
    // 向上移课程源
    toTopCourseItem(index, num) {
      let prev = this.form2.chapterList[index].sourceList[num - 1]
      let next = this.form2.chapterList[index].sourceList[num]
      this.form2.chapterList[index].sourceList[num - 1] = JSON.parse(JSON.stringify(next))
      this.form2.chapterList[index].sourceList[num] = JSON.parse(JSON.stringify(prev))
      this.$forceUpdate()
    },
    // 删除课程源
    removeCourseItem(index, num) {
      this.form2.chapterList[index].sourceList.splice(num, 1)
      this.$forceUpdate()
    },
    // 添加章节
    addChapter() {
      let chapterListItem = {
        name: '',
        sourceList: [],
        weight: this.form2.chapterList.length
      }
      this.form2.chapterList.push(chapterListItem)
      this.$forceUpdate()
    },
    // 删除章节
    removeChapter(index) {
      this.$confirm(' 删除章节将同步删除下属目录，请确认是否删除?', '删除章节', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.form2.chapterList.splice(index, 1)
          this.$forceUpdate()
          this.$message.success('删除成功！')
        })
        .catch(() => {
          this.$message.info('已取消删除！')
        })
    },
    // 数据太复杂，无法实时更新dom
    updateDom(val) {
      this.$forceUpdate()
    },
    // 提交添加课程
    submitStep2(extraData = {}) {
      this.$refs.secondStep.validate((valid) => {
        if (valid) {
          if (!this.validSecondData()) {
            return
          }
          this.submitStep = true
          // 课程类型
          let courseExtra = {
            courseId: this.courseId
          }
          let time = this.$refs.datetimerange.getTime

          // 学科处理
          let disciplines = this.form.disciplines.filter((item) => item.disciplineId != -1)
          debugger
          let data = {
            // 第一步
            id: this.courseId,
            title: this.form.title, //名称
            createTime: this.form.createTime || this.$moment().format('YYYY-MM-DD HH:mm:ss'),
            offlineTime: this.form.offlineTime,
            disciplines: disciplines, // 学科
            subjectType: this.form.subjectType.join(','), // 课程专题
            courseType: this.form.courseType.join(','), // 课程类型
            isVipExclusive: this.form.isVipExclusive, // 会员专享
            advertisingSlogan: this.form.advertisingSlogan, //广告语
            startVersion: this.form.startVersion,
            endVersion: this.form.endVersion,
            locationUrl: this.form.locationUrl,
            coverImg: this.form.coverImg, //封面图
            miniCardImg: this.form.miniCardImg || this.form.coverImg, //小程序卡片图
            shareImg: this.form.shareImg || this.form.coverImg, //分享小图
            shareTitle: this.form.shareTitle || this.form.title, //分享标题
            shareDesc: this.form.shareDesc || '学好医，上呗呗',
            marketingText: this.form.marketingText,
            shareable: this.form.shareable, //允许分享
            overt: this.form.overt, //公开课程
            freeMembership: this.form.freeMembership, //会员免费
            types: this.form.types.join(','), // 课程类型
            subType: this.form.subType, // 课程类型
            // vipFree:this.form.vipFree,
            summary: this.form.summary, //课程简介
            userType: 2, //1：孕妈 2：医生
            courseExtra: courseExtra,
            hasCert: this.form.hasCert, //是否开启荣誉证书
            certInfo: this.form.courseCertificationDto,
            tags: this.tags.map((item) => item.name), //课程卖点
            contractCode: this.contractCode, //合同编号
            confirmCode: this.confirmCode,
            // 第二步
            price: exchange.toWallet(this.form2.price), //销售价格
            drawProportion: this.form2.isDraw === 1 ? this.form2.drawProportion : 0,
            cost: this.form2.isDraw === 1 ? exchange.toWallet(this.form2.cost) : 0,
            chapterList: this.secondStepChapterList,
            vipFree: this.form.vipFreeFlag == 0 ? 0 : this.form.vipFree || 1,
            isWapWatch: this.form.isWapWatch,
            collectionSubjectId: this.collectionSubjectId
            //结算主体
          }
          // 添加额外信息
          Object.assign(data, extraData)
          this.isPublish = extraData.offline != undefined ? true : false

          if(this.form.courseType.includes(1)) {
            data.advertise = this.form.advertise // 广告类型
          }

          const api = this.PAGEKEY == 'docCourse_edit' ? docCourseApi.editCourse : docCourseApi.addCourse

          api(data)
            .then((res) => {
              if (res.Success) {
                this.$message.success('修改成功！')
                this.closePage()
              } else {
                this.$message.error(res.Msg)
              }
              this.submitStep = false
            })
            .catch((res) => {
              this.submitStep = false
              this.$message.error('修改失败，请稍后再试！')
            })
        } else {
          this.$message.error('您有信息未正确填写！')
          return false
        }
      })
    },
    // 发布
    publish() {
      this.submitStep2({
        offline: 0
      })
    },
    // 关闭tab
    closePage() {
      this.$store.dispatch('tabs/removeSpecifiedTab', this.PAGEKEY)
      this.$store.dispatch('tabs/toTargetTab', this.PAGEBACK)
    },
    //切换科室
    changeTab(index) {
      console.log(index)
      this.tab = index
    }
  },
  filters: {
    courseTagFilter([state, type]) {
      if (type == 1 && state == 4) {
        return '回顾'
      } else if (type == 1 && state != 4) {
        return '直播'
      } else if (type == 2 || type == 4) {
        return '视频'
      } else if (type == 3) {
        return '线下'
      } else if (type == 5) {
        return '课件'
      } else if (type == 7) {
        return '网页'
      } else if (type == 8) {
        return '音频'
      } else if (type == 10) {
        return '评测'
      } else {
        return '未知'
      }
    },
    timeFilter(data) {
      let duration = data.duration ? data.duration : 0
      let planStartTime = data.planStartTime ? data.planStartTime : '暂无'
      if (data.type == 1 && data.state == 4) {
        // return parseInt(duration/60)+'分钟'
        return
      } else if (data.type == 1 && (data.state == 1 || data.state == 2)) {
        return '开课时间：' + planStartTime
      } else if (data.type == 2 || data.type == 4) {
        // return parseInt(duration/60)+'分钟'
        return
      } else if (data.type == 3) {
        return '开课时间：' + planStartTime
      } else if (data.type == 5) {
        return
      } else {
        return ''
      }
    }
  }
}
</script>

<style type="text/less" lang="less" scoped>
.courseItem_weight {
  width: 150px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 10px;

  .inp {
    width: 150px;
    margin: 0 20px;
  }
}
.card_warp {
  padding-top: 10px;
  padding-bottom: 10px;
}

form {
  .avatar {
    width: 81px;
    height: 81px;
  }

  .icon-picture-add {
    line-height: 60px;
    font-size: 70px;
  }
}

.tag-wrap {
  max-height: 200px;
  overflow-y: auto;

  .self-tag-item {
    cursor: pointer;
    margin-right: 10px;
    margin-bottom: 5px;
  }

  .self-tag-choiced {
    display: none;
  }
}

.dialog_row {
  max-height: 600px;
  overflow: auto;
}

.courseList {
  margin-bottom: 10px;
  margin-left: 30px;

  .courseList_title {
    width: 50%;
  }

  .courseList_opearte {
    float: right;
    padding: 3px 0 3px 5px;
  }
}

.courseBody {
  font-size: 14px;
}

.courseItem {
  position: relative;
  margin-bottom: 30px;
  font-size: 14px;

  p {
    margin: 5px 0;
  }

  .courseItem_tag {
    width: 40px;
    text-align: center;
  }

  .courseItem_detail {
    padding-left: 43px;

    span {
      padding-right: 5px;
    }
  }

  .courseItem_opearte {
    position: absolute;
    top: 5px;
    right: 5px;

    i {
      font-weight: bold;
      cursor: pointer;
    }
  }
}

.courseItem_draw {
  padding-left: 20px;
  font-size: 14px;

  p {
    margin: 0 0 5px;
  }

  .input {
    width: 130px;
  }
  .select_span {
    text-align: right;
    padding-right: 15px;
    span {
      font-size: 14px;
    }
  }
}
.courseItem_free {
  padding-left: 20px;
  font-size: 14px;
}
.select_box {
  display: flex;
}
.select_ul {
  flex: none;
  width: 120px;
  height: 200px;
  list-style: none;
  overflow-y: auto;
  background: #f2f2f2;
  margin: 0;
  padding: 0;
  text-align: center;
  .active {
    color: #fff;
    background: #409eff;
  }
  li {
    cursor: pointer;
    line-height: 1.4;
    padding: 10px 10px;
    box-sizing: border-box;
    border-bottom: 1px solid #ddd;
    &:nth-last-child(1) {
      border-bottom: none;
    }
  }
  &.tag-wrap {
    flex: 1;
    text-align: left;
    li {
      cursor: default;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/contentManage/docCourseManage/components/page.vue